import { useTransition } from 'react';
import Button from '@components/Button';
import IconMdi from '@components/IconMdi';
import { mdiDownload } from '@mdi/js';
import { fetchBlocksCSVDownloadUrl } from '@queries/fetchBlocks';
import { fetchSubmissionsCSVDownloadUrl } from '@queries/fetchSubmissions';
import { fetchTemplatesCSVDownloadUrl } from '@queries/fetchTemplates';
import { fetchUsersCSVDownloadUrl } from '@queries/fetchUsers';
import { withPROGuard } from '@root/src/utils';

type DownloadCSVType = 'submissions' | 'clauses' | 'blocks' | 'templates' | 'users';

const getS3DownloadUrl = async (type: DownloadCSVType) => {
  if (type === 'submissions') {
    return fetchSubmissionsCSVDownloadUrl();
  }
  if (type === 'blocks') {
    return fetchBlocksCSVDownloadUrl({ type: 'block' });
  }
  if (type === 'templates') {
    return fetchTemplatesCSVDownloadUrl();
  }
  if (type === 'users') {
    return fetchUsersCSVDownloadUrl();
  }

  return fetchBlocksCSVDownloadUrl({ type: 'clause' });
};

const DownloadCSVButtonInner = ({ type }: { type: DownloadCSVType }) => {
  const [isPending, startTransition] = useTransition();

  const handleDownloadCSV = () => {
    startTransition(async () => {
      const url = await getS3DownloadUrl(type);
      const a = document.createElement('a');

      a.href = url;
      a.download = `${type}-${new Date().toISOString().split('T')[0]}.csv`;

      a.click();
      a.remove();
    });
  };

  return (
    <Button
      className="mt-[2px] mr-2 ml-auto h-[38px] w-[126px] whitespace-nowrap"
      onClick={handleDownloadCSV}
      kind="secondary"
      size="sm"
      isDisabled={isPending}
    >
      <IconMdi className="text-info-400" size={0.83} path={mdiDownload} />
      Download
    </Button>
  );
};

export const DownloadCSVButton = withPROGuard(DownloadCSVButtonInner);
